import { AlphaIBoxIcon } from './AlphaIBoxIcon';

/**
 * author: GreenTurtwig
 * id 4D933A0E-88F5-4712-8BA1-0E60290A6623
 * name alpha-i-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterIBoxIcon = AlphaIBoxIcon;
export default LetterIBoxIcon